var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 23,
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 7500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00_Data Connection overview"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7919_328307)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -29,
    y: -816,
    width: 1440,
    height: 1024,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "my_account"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -28.5,
    y: -815.5,
    width: 1439,
    height: 1754,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -28.5,
    y: -815.5,
    width: 1439,
    height: 1754,
    stroke: "#9DA0A5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "menue-item-collapsed / VP-L"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    x: -29,
    y: -816,
    width: 80,
    height: 1024,
    fill: "#434345"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 7156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menue-item-VP-L"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 88",
    x: -29,
    y: -16,
    width: 80,
    height: 56,
    fill: "#2AA7DF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "menue-item-icon",
    clipPath: "url(#clip1_7919_328307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-system/administrator"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 121",
    d: "M9.10521 5.48669L5.06252 7.73",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 107",
    cx: 16.227,
    cy: 12.5531,
    r: 2.66447,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.64748 0.789786C8.93502 0.641523 9.27652 0.641523 9.56406 0.789786L17.1229 4.68734C17.4839 4.87346 17.6965 5.2594 17.6608 5.66396L17.5241 7.21408C17.1076 7.11309 16.6726 7.05957 16.225 7.05957C15.9883 7.05957 15.755 7.07455 15.5261 7.10361L15.6096 6.15721L9.10577 2.8037L2.59205 6.16233L2.71804 7.89867C3.02896 12.1834 5.6348 15.9643 9.52837 17.7798C9.55283 17.7912 9.58208 17.8045 9.6149 17.8194C9.70051 17.8584 9.81039 17.9084 9.92278 17.9644C9.59819 18.357 9.32004 18.8006 9.10621 19.3011C9.05158 19.429 9.00254 19.5537 8.9588 19.6755C8.86564 19.6616 8.77289 19.6342 8.68317 19.5924C4.13238 17.4704 1.08668 13.0514 0.723289 8.04341L0.54951 5.64851C0.520526 5.24908 0.732646 4.87088 1.0886 4.68734L8.64748 0.789786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 119"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-9-outside-1_7919_328307",
    maskUnits: "userSpaceOnUse",
    x: 10.5273,
    y: 16.9218,
    width: 12,
    height: 6,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 10.5273,
    y: 16.9218,
    width: 12,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5273 20.8818H19.9231C18.0879 18.4077 14.3745 18.4166 12.5273 20.8818Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.5273 20.8818L10.9268 19.6825C10.4726 20.2886 10.3998 21.0993 10.7387 21.7766C11.0776 22.4539 11.77 22.8818 12.5273 22.8818V20.8818ZM19.9231 20.8818V22.8818C20.6788 22.8818 21.3699 22.4559 21.7096 21.7809C22.0493 21.1059 21.9796 20.2971 21.5294 19.6902L19.9231 20.8818ZM12.5273 22.8818H19.9231V18.8818H12.5273V22.8818ZM21.5294 19.6902C18.8885 16.13 13.5677 16.1579 10.9268 19.6825L14.1279 22.081C15.1812 20.6752 17.2873 20.6854 18.3168 22.0733L21.5294 19.6902Z",
    fill: "white",
    mask: "url(#path-9-outside-1_7919_328307)"
  }))))))))), /*#__PURE__*/React.createElement("rect", {
    x: -28.5,
    y: -815.5,
    width: 1439,
    height: 1023,
    stroke: "#9DA0A5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7919_328307"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -29,
    y: -816,
    width: 1440,
    height: 1024,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7919_328307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(-1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminPage);
export default __webpack_public_path__ + "static/media/admin_page.2818f82ff8912582f4603748297c51f3.svg";
export { ForwardRef as ReactComponent };